/* Okira Custom JavaScript - Smooth Scroll & Animations */

document.addEventListener('DOMContentLoaded', () => {
  // --- 1. Hero Content Entrance Animation ---
  setTimeout(() => {
    const heroContent = document.querySelector('.okira-hero__content');
    if (heroContent) {
      heroContent.classList.add('is-visible');
    }
  }, 350);

  // --- 2. Custom Mobile Menu Drawer ---
  document.addEventListener('click', (e) => {
    // Open drawer
    const menuBtn = e.target.closest('.okira-header__menu-btn');
    if (menuBtn) {
      e.preventDefault();
      const drawers = document.querySelectorAll('.okira-drawer');
      drawers.forEach(d => d.classList.add('is-active'));
      document.body.classList.add('overflow-hidden');
      return;
    }

    // Close drawer button
    const closeBtn = e.target.closest('.okira-drawer__close');
    if (closeBtn) {
      e.preventDefault();
      const drawers = document.querySelectorAll('.okira-drawer');
      drawers.forEach(d => d.classList.remove('is-active'));
      document.body.classList.remove('overflow-hidden');
      return;
    }

    // Close on link click
    const drawerLink = e.target.closest('.okira-drawer__link');
    if (drawerLink) {
      const drawers = document.querySelectorAll('.okira-drawer');
      drawers.forEach(d => d.classList.remove('is-active'));
      document.body.classList.remove('overflow-hidden');
      return;
    }

    // Close on clicking backdrop/outside drawer content
    if (e.target.classList.contains('okira-drawer') && e.target.classList.contains('is-active')) {
      e.target.classList.remove('is-active');
      document.body.classList.remove('overflow-hidden');
    }
  });

  // Global Header: Visible on scroll up with off-white background; hidden on scroll down
  const globalHeader = document.querySelector('.okira-header--global');
  if (globalHeader) {
    let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const heroThreshold = 180; // Past the top hero area

    const handleScroll = () => {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll <= heroThreshold) {
        // Back at top of page: restore transparent overlay hero state
        globalHeader.classList.remove('is-sticky', 'is-hidden', 'is-visible-scrollup');
      } else {
        // Scrolled down past hero: sticky mode enabled
        globalHeader.classList.add('is-sticky');

        if (currentScroll < lastScrollTop - 6) {
          // Scrolling UP: reveal navbar in off-white
          globalHeader.classList.remove('is-hidden');
          globalHeader.classList.add('is-visible-scrollup');
        } else if (currentScroll > lastScrollTop + 6) {
          // Scrolling DOWN: hide navbar
          globalHeader.classList.remove('is-visible-scrollup');
          globalHeader.classList.add('is-hidden');
        }
      }

      lastScrollTop = Math.max(0, currentScroll);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }
});

// --- 3. Native Smooth Scrolling Optimization ---
// Note: Wheel-hijacking lerp loops fight against browser compositor pipelines and cause micro-stutters and input lag.
// We use passive listeners and requestAnimationFrame for all scroll-driven visual effects to ensure 60/120fps smoothness.


// --- 4. High-Performance Scroll-Clamped Marquee (Zero-Jitter Translation Loop) ---
let marqueePosition = 0;
let lastScrollTop = window.scrollY;
let marqueeScrollSpeed = 0;
const marqueeBaseSpeed = 0.6; // Cruising speed (pixels per frame) - very slow & premium
let marqueeCurrentSpeed = marqueeBaseSpeed;

window.addEventListener('scroll', () => {
  const scrollTop = window.scrollY;
  const delta = Math.abs(scrollTop - lastScrollTop);
  lastScrollTop = scrollTop;
  marqueeScrollSpeed = Math.min(delta, 100); // Track scroll velocity, clamped
});

function updateMarquee() {
  const marqueeInner = document.querySelector('.okira-bottom-marquee__inner');
  if (marqueeInner) {
    // Target speed is base speed plus scroll boost (only scales up)
    const targetSpeed = marqueeBaseSpeed + (marqueeScrollSpeed * 0.12);
    
    // Smoothly interpolate current speed (lerp)
    marqueeCurrentSpeed += (targetSpeed - marqueeCurrentSpeed) * 0.08;

    // Decay the scroll boost back to 0
    marqueeScrollSpeed *= 0.92;

    // Increment translation coordinates (always moves right to left)
    marqueePosition -= marqueeCurrentSpeed;

    // Seamless wrapping check using half width (since content loop is duplicated)
    const halfWidth = marqueeInner.scrollWidth / 2;
    if (Math.abs(marqueePosition) >= halfWidth) {
      // Wrap coordinates seamlessly without visible jump
      marqueePosition = 0;
    }

    // Apply translation directly
    marqueeInner.style.transform = `translate3d(${marqueePosition}px, 0, 0)`;
  }
  requestAnimationFrame(updateMarquee);
}
requestAnimationFrame(updateMarquee);

// --- 5. Hero Background Parallax Effect ---
let parallaxTicking = false;
function updateParallax() {
  const bgImg = document.querySelector('.okira-hero__bg-img');
  if (bgImg) {
    if (window.innerWidth < 990) {
      bgImg.style.transform = '';
      return;
    }
    const scrollTop = window.scrollY;
    // Pushes background image down by 35% of scroll distance
    const parallaxOffset = scrollTop * 0.35;
    bgImg.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`;
  }
  parallaxTicking = false;
}
function onParallaxScroll() {
  if (!parallaxTicking) {
    window.requestAnimationFrame(updateParallax);
    parallaxTicking = true;
  }
}
window.addEventListener('scroll', onParallaxScroll, { passive: true });
// Initialize on load to prevent jumping
document.addEventListener('DOMContentLoaded', updateParallax);

// --- 6. Featured Products Carousel Slider Navigation ---
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.okira-products__slider');
  sliders.forEach(slider => {
    const container = slider.closest('.okira-products__container');
    if (!container) return;
    const prevBtn = container.querySelector('.okira-products__nav-btn--prev');
    const nextBtn = container.querySelector('.okira-products__nav-btn--next');

    if (prevBtn && nextBtn) {
      // Step amount matches average card width + gap
      const scrollAmount = window.innerWidth >= 990 ? 360 : 300;

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
  });
});

// --- 7. IntersectionObserver for Scroll Pop-ups ---
document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.okira-lifestyle-section, .okira-products-section, .okira-about-section, .okira-lifestyle__cards-row, .okira-features-section, .okira-reviews-section');
  
  const observerOptions = {
    root: null,
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.30
  };

  const observer = new IntersectionObserver((entries, self) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        self.unobserve(entry.target);
      }
    });
  }, observerOptions);

  sections.forEach(section => {
    observer.observe(section);
  });
});

// --- 7.5. Reviews Carousel Slider Navigation ---
document.addEventListener('DOMContentLoaded', () => {
  const sliders = document.querySelectorAll('.okira-reviews__slider');
  sliders.forEach(slider => {
    const container = slider.closest('.okira-reviews__container');
    if (!container) return;
    const prevBtn = container.querySelector('.okira-reviews__nav-btn--prev');
    const nextBtn = container.querySelector('.okira-reviews__nav-btn--next');

    if (prevBtn && nextBtn) {
      const scrollAmount = window.innerWidth >= 990 ? 380 : 300;

      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        slider.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
    }
  });
});

// --- 8. Lifestyle Section Background Parallax ---
function updateLifestyleParallax() {
  const section = document.querySelector('.okira-lifestyle-section');
  if (!section) return;

  const bgImg = section.querySelector('.okira-lifestyle__bg');
  if (!bgImg) return;

  if (window.innerWidth < 990) {
    bgImg.style.transform = '';
    return;
  }

  const rect = section.getBoundingClientRect();
  const viewportHeight = window.innerHeight;

  // Trigger only when the section is visible in the viewport
  if (rect.top < viewportHeight && rect.bottom > 0) {
    const totalDist = viewportHeight + rect.height;
    const currentDist = viewportHeight - rect.top;
    const ratio = currentDist / totalDist; // 0 to 1

    // Translate from -60px to 60px (smooth travel)
    const travel = (ratio - 0.5) * 120;
    bgImg.style.transform = `translate3d(0, ${travel}px, 0)`;
  }
}

let lifestyleTicking = false;
function onLifestyleScroll() {
  if (!lifestyleTicking) {
    window.requestAnimationFrame(() => {
      updateLifestyleParallax();
      lifestyleTicking = false;
    });
    lifestyleTicking = true;
  }
}
window.addEventListener('scroll', onLifestyleScroll, { passive: true });
document.addEventListener('DOMContentLoaded', updateLifestyleParallax);

// --- 9. About Section Scroll-Driven Color Highlight ---
document.addEventListener('DOMContentLoaded', () => {
  const heading = document.querySelector('.okira-about__heading');
  if (!heading) return;
  const chars = heading.querySelectorAll('.okira-about__heading-char');
  
  const handleScrollColor = () => {
    const rect = heading.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Start highlighting when heading is 55% down the viewport (middle-ish), finish by 20% down
    const start = viewportHeight * 0.55;
    const end = viewportHeight * 0.20;
    const totalDistance = start - end;
    
    const currentPos = rect.top;
    let progress = (start - currentPos) / totalDistance;
    progress = Math.max(0, Math.min(1, progress));
    
    const totalChars = chars.length;
    const activeCount = Math.floor(progress * totalChars);
    for (let i = 0; i < totalChars; i++) {
      const shouldColor = i < activeCount;
      if (chars[i].classList.contains('is-colored') !== shouldColor) {
        if (shouldColor) {
          chars[i].classList.add('is-colored');
        } else {
          chars[i].classList.remove('is-colored');
        }
      }
    }
  };
  
  let colorTicking1 = false;
  const onColorScroll1 = () => {
    if (!colorTicking1) {
      window.requestAnimationFrame(() => {
        handleScrollColor();
        colorTicking1 = false;
      });
      colorTicking1 = true;
    }
  };

  window.addEventListener('scroll', onColorScroll1, { passive: true });
  window.addEventListener('resize', handleScrollColor);
  handleScrollColor();
});

// --- 9.5. Features Section Scroll-Driven Color Highlight ---
document.addEventListener('DOMContentLoaded', () => {
  const heading = document.querySelector('.okira-features__heading');
  if (!heading) return;
  const chars = heading.querySelectorAll('.okira-features__heading-char');
  
  const handleScrollColor = () => {
    const rect = heading.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Start highlighting when heading is 60% down the viewport, finish by 25% down
    const start = viewportHeight * 0.60;
    const end = viewportHeight * 0.25;
    const totalDistance = start - end;
    
    const currentPos = rect.top;
    let progress = (start - currentPos) / totalDistance;
    progress = Math.max(0, Math.min(1, progress));
    
    const totalChars = chars.length;
    const activeCount = Math.floor(progress * totalChars);
    for (let i = 0; i < totalChars; i++) {
      const shouldColor = i < activeCount;
      if (chars[i].classList.contains('is-colored') !== shouldColor) {
        if (shouldColor) {
          chars[i].classList.add('is-colored');
        } else {
          chars[i].classList.remove('is-colored');
        }
      }
    }
  };
  
  let colorTicking2 = false;
  const onColorScroll2 = () => {
    if (!colorTicking2) {
      window.requestAnimationFrame(() => {
        handleScrollColor();
        colorTicking2 = false;
      });
      colorTicking2 = true;
    }
  };

  window.addEventListener('scroll', onColorScroll2, { passive: true });
  window.addEventListener('resize', handleScrollColor);
  handleScrollColor();
});

// --- 10. About Section Clouds Mouse Parallax ---
document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.okira-about__clouds-container');
  if (!container) return;
  
  const cloud1 = container.querySelector('.okira-cloud-wrapper--1');
  const cloud2 = container.querySelector('.okira-cloud-wrapper--2');
  const cloud3 = container.querySelector('.okira-cloud-wrapper--3');
  
  container.addEventListener('mousemove', (e) => {
    const rect = container.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    // Normalize coordinates: center is (0, 0), ranges from -0.5 to 0.5
    const normX = (x / rect.width) - 0.5;
    const normY = (y / rect.height) - 0.5;
    
    // Apply smooth transform parallax translations (depth layer effect)
    if (cloud1) {
      cloud1.style.transform = `translate3d(${normX * 50}px, ${normY * 40}px, 0)`;
    }
    if (cloud2) {
      cloud2.style.transform = `translate3d(${normX * -35}px, ${normY * 30}px, 0)`;
    }
    if (cloud3) {
      cloud3.style.transform = `translate3d(${normX * 25}px, ${normY * -45}px, 0)`;
    }
  });
  
  container.addEventListener('mouseleave', () => {
    // Reset positions smoothly when cursor leaves
    if (cloud1) cloud1.style.transform = 'translate3d(0, 0, 0)';
    if (cloud2) cloud2.style.transform = 'translate3d(0, 0, 0)';
    if (cloud3) cloud3.style.transform = 'translate3d(0, 0, 0)';
  });
});

// --- 11. Features Section Scroll Parallax (Paddles scale & Cloud badges move inward) ---
document.addEventListener('DOMContentLoaded', () => {
  const section = document.querySelector('.okira-features-section');
  if (!section) return;
  
  const paddlesImg = section.querySelector('.okira-features__paddles-img');
  const badgeTitleLeft = section.querySelector('.okira-cloud-badge--title-left');
  const badgeTitleRight = section.querySelector('.okira-cloud-badge--title-right');
  const badgePaddlesLeft = section.querySelector('.okira-cloud-badge--paddles-left');
  const badgePaddlesRight = section.querySelector('.okira-cloud-badge--paddles-right');
  
  const handleScrollParallax = () => {
    if (window.innerWidth < 990) {
      if (paddlesImg) paddlesImg.style.transform = '';
      if (badgeTitleLeft) badgeTitleLeft.style.transform = '';
      if (badgeTitleRight) badgeTitleRight.style.transform = '';
      if (badgePaddlesLeft) badgePaddlesLeft.style.transform = '';
      if (badgePaddlesRight) badgePaddlesRight.style.transform = '';
      return;
    }

    const rect = section.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    
    // Check if section is currently active/visible in viewport
    if (rect.top < viewportHeight && rect.bottom > 0) {
      // Calculate scroll progress (0 when section top enters, 1 when section bottom leaves viewport)
      const totalDistance = rect.height + viewportHeight;
      const progress = (viewportHeight - rect.top) / totalDistance;
      
      const isDesktop = window.innerWidth >= 750;
      const baseScale = isDesktop ? 1.9 : 1.6;
      // Paddles scale up dramatically on scroll down
      const targetScale = baseScale + (progress * 0.45);
      
      if (paddlesImg && section.classList.contains('is-visible')) {
        paddlesImg.style.transform = `translate3d(-50%, 0, 0) scale(${targetScale})`;
      }
      
      // Clouds move inward towards paddles (left clouds shift right, right clouds shift left)
      const moveDistance = isDesktop ? 80 : 35;
      const shiftX = progress * moveDistance;
      
      if (badgeTitleLeft) {
        badgeTitleLeft.style.transform = `translate3d(${shiftX}px, 0, 0)`;
      }
      if (badgeTitleRight) {
        badgeTitleRight.style.transform = `translate3d(${-shiftX}px, 0, 0)`;
      }
      if (badgePaddlesLeft) {
        badgePaddlesLeft.style.transform = `translate3d(${shiftX}px, 0, 0)`;
      }
      if (badgePaddlesRight) {
        badgePaddlesRight.style.transform = `translate3d(${-shiftX}px, 0, 0)`;
      }
    }
  };
  
  let featuresTicking = false;
  const onFeaturesScroll = () => {
    if (!featuresTicking) {
      window.requestAnimationFrame(() => {
        handleScrollParallax();
        featuresTicking = false;
      });
      featuresTicking = true;
    }
  };

  window.addEventListener('scroll', onFeaturesScroll, { passive: true });
  window.addEventListener('resize', handleScrollParallax);
  handleScrollParallax();
});

// --- 12. About Section Slanted Images Entrance Animation & Parallax ---
function initSlantedCollage() {
  const slantedCollage = document.querySelector('.okira-slanted-collage');
  if (!slantedCollage) return;

  const items = slantedCollage.querySelectorAll('.okira-slanted-item');
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        items.forEach(item => item.classList.add('is-visible'));
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.3 });
  observer.observe(slantedCollage);

  // Parallax setup
  items.forEach(item => {
    const img = item.querySelector('.okira-slanted-img');
    if (!img) return;
    
    item.addEventListener('mousemove', (e) => {
      const rect = item.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      
      const normX = (x / rect.width) - 0.5;
      const normY = (y / rect.height) - 0.5;
      
      const moveX = normX * 40;
      const moveY = normY * 40;
      
      img.style.setProperty('--parallax-x', `${moveX}px`);
      img.style.setProperty('--parallax-y', `${moveY}px`);
    });
    
    item.addEventListener('mouseleave', () => {
      img.style.setProperty('--parallax-x', '0px');
      img.style.setProperty('--parallax-y', '0px');
    });
  });
}

// --- 13. About Section Paragraph Line-by-Line Reveal ---
function initLineReveal() {
  const element = document.querySelector('.okira-about__text');
  if (!element) return;

  // Save original text if not already saved to allow clean recalculations on window resize
  if (!element.dataset.originalText) {
    element.dataset.originalText = element.textContent.trim();
  }

  const originalText = element.dataset.originalText;
  const words = originalText.split(/\s+/);
  
  // Wrap each word in a temporary inline span to calculate its vertical offset (line)
  element.innerHTML = words.map(word => `<span class="temp-word" style="display: inline-block;">${word}</span>`).join(' ');
  
  const spans = element.querySelectorAll('.temp-word');
  const linesMap = {};
  
  spans.forEach(span => {
    const top = span.offsetTop;
    if (!linesMap[top]) {
      linesMap[top] = [];
    }
    linesMap[top].push(span.textContent);
  });
  
  // Re-build element HTML grouping words into line-masks
  let newHtml = '';
  let lineIndex = 0;
  const sortedTops = Object.keys(linesMap).sort((a, b) => parseFloat(a) - parseFloat(b));
  sortedTops.forEach(top => {
    const lineWords = linesMap[top].join(' ');
    newHtml += `<span class="okira-about-line-wrapper">
      <span class="okira-about-line" style="transition-delay: ${0.25 + lineIndex * 0.2}s;">${lineWords}</span>
    </span>`;
    lineIndex++;
  });
  
  element.innerHTML = newHtml;
}

// Run immediately or on DOM load
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initSlantedCollage();
    initLineReveal();
  });
} else {
  initSlantedCollage();
  initLineReveal();
}

// Window resize handler with debounce for performance
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initLineReveal, 150);
});

// Support Shopify Customizer hot reloading & dev server section updates
document.addEventListener('shopify:section:load', (e) => {
  if (e.target.querySelector('.okira-slanted-collage')) {
    initSlantedCollage();
  }
  if (e.target.querySelector('.okira-about__text')) {
    initLineReveal();
  }
  if (e.target.querySelector('.okira-collection-section')) {
    initCollectionGrid();
  }
});

// --- Okira Collection Grid Functions ---
function initCollectionGrid() {
  const filterBtns = document.querySelectorAll('.okira-filter-btn');
  const gridItems = document.querySelectorAll('.okira-collection-card-item');
  const gridContainer = document.getElementById('OkiraCollectionGrid');
  
  if (!gridItems.length) return;

  // Initial Staggered Entrance Animation
  gridItems.forEach((item, index) => {
    setTimeout(() => {
      item.classList.add('show');
    }, index * 80);
  });

  // Filter Button Clicking
  filterBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      
      const filterVal = btn.getAttribute('data-filter');

      // Sync active state across ALL filter pill groups (desktop + mobile)
      filterBtns.forEach(b => {
        if (b.getAttribute('data-filter') === filterVal) {
          b.classList.add('active');
        } else {
          b.classList.remove('active');
        }
      });

      // Re-query items fresh each time to avoid stale NodeList
      const currentItems = document.querySelectorAll('.okira-collection-card-item');

      // Staggered exit/entry filter animation
      let visibleIndex = 0;
      currentItems.forEach(item => {
        const itemType = (item.getAttribute('data-type') || '').toLowerCase().trim();
        const itemTitle = (item.getAttribute('data-title') || '').toLowerCase().trim();
        const itemHandle = (item.getAttribute('data-handle') || '').toLowerCase().trim();
        const tags = (item.getAttribute('data-tags') || '').toLowerCase();
        const tagList = tags.split(',').map(t => t.trim()).filter(Boolean);
        const filter = filterVal.toLowerCase().trim();

        let matches = false;
        if (filter === 'all') {
          matches = true;
        } else if (filter === 'paddle') {
          matches = itemType === 'paddle' || itemType === 'paddles';
        } else if (filter === 'carbon-fiber' || filter === '3k-carbon-fibre') {
          // Matches all carbon fiber paddles: 12K, 3K, T700, or any tagged/titled with carbon
          const isCarbon = itemTitle.includes('carbon') || 
                           itemTitle.includes('12k') || 
                           itemTitle.includes('3k') || 
                           itemTitle.includes('t700') ||
                           itemHandle.includes('carbon') || 
                           itemHandle.includes('12k') || 
                           itemHandle.includes('3k') || 
                           itemHandle.includes('t700') ||
                           tagList.some(t => t.includes('carbon') || t.includes('12k') || t.includes('3k') || t.includes('t700'));
          matches = (itemType === 'paddle' || itemType === 'paddles' || itemType.includes('carbon')) && isCarbon;
        } else if (filter === 'combo' || filter === 'combos' || filter === 'paddle-combos') {
          // Matches combo products by title, handle, type, or tag (e.g. Okira Neo Combo, OKIRA POP COMBO)
          matches = itemTitle.includes('combo') || 
                    itemHandle.includes('combo') || 
                    itemType.includes('combo') || 
                    tagList.some(t => t.includes('combo'));
        } else if (filter === 'pickle-ball') {
          matches = itemType === 'pickle-ball';
        } else if (filter === 'paddle-cover' || filter === 'accessories') {
          matches = itemType === 'paddle-cover';
        } else {
          matches = itemType.includes(filter) || itemTitle.includes(filter) || itemHandle.includes(filter) || tagList.some(t => t.includes(filter));
        }

        if (matches) {
          item.style.display = 'flex';
          setTimeout(() => {
            item.classList.add('show');
          }, visibleIndex * 60 + 50);
          visibleIndex++;
        } else {
          item.classList.remove('show');
          setTimeout(() => {
            item.style.display = 'none';
          }, 300);
        }
      });
    });
  });

  // Sort function shared between both selects
  function applySortValue(sortValue) {
    const items = Array.from(gridContainer.querySelectorAll('.okira-collection-card-item'));
    items.sort((a, b) => {
      if (sortValue === 'price-low-high') {
        return parseFloat(a.getAttribute('data-price')) - parseFloat(b.getAttribute('data-price'));
      } else if (sortValue === 'price-high-low') {
        return parseFloat(b.getAttribute('data-price')) - parseFloat(a.getAttribute('data-price'));
      } else if (sortValue === 'title-a-z') {
        return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
      } else if (sortValue === 'title-z-a') {
        return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
      } else {
        return parseInt(a.getAttribute('data-index')) - parseInt(b.getAttribute('data-index'));
      }
    });
    items.forEach(item => gridContainer.appendChild(item));
  }

  // Sorters Dropdown Change Handler (desktop)
  const sortBySelect = document.getElementById('OkiraSortBy');
  const sortByMobile = document.getElementById('OkiraSortByMobile');

  if (sortBySelect && gridContainer) {
    sortBySelect.addEventListener('change', () => {
      applySortValue(sortBySelect.value);
      if (sortByMobile) sortByMobile.value = sortBySelect.value; // sync
    });
  }

  // Mobile sort select handler
  if (sortByMobile && gridContainer) {
    sortByMobile.addEventListener('change', () => {
      applySortValue(sortByMobile.value);
      if (sortBySelect) sortBySelect.value = sortByMobile.value; // sync
    });
  }

  // --- Real Shopify AJAX Add-to-Cart ---
  const ajaxAddBtns = document.querySelectorAll('.okira-ajax-add');
  ajaxAddBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();

      const variantId = btn.getAttribute('data-variant-id');
      const productTitle = btn.getAttribute('data-product-title');

      // If no variant ID (demo cards), show info toast
      if (!variantId) {
        showOkiraToast(`${productTitle} — Add products in Shopify Admin to enable cart`, 'info');
        return;
      }

      // Disable button during request
      btn.disabled = true;
      const originalText = btn.innerHTML;
      btn.innerHTML = '<span class="okira-btn-spinner"></span>';

      const cartDrawer = document.querySelector('cart-drawer');
      const sections = cartDrawer ? cartDrawer.getSectionsToRender().map(s => s.id) : [];

      fetch(window.routes?.cart_add_url || '/cart/add.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }],
          sections: sections
        })
      })
      .then(response => {
        if (!response.ok) {
          return response.json().then(err => { throw err; });
        }
        return response.json();
      })
      .then(data => {
        // Success — show toast
        showOkiraToast(`Added ${productTitle} to cart!`, 'success');
        
        if (cartDrawer && data.sections) {
          cartDrawer.renderContents(data);
        } else {
          updateCartCount();
        }
      })
      .catch(err => {
        const errorMsg = err.description || err.message || 'Could not add to cart';
        showOkiraToast(errorMsg, 'error');
      })
      .finally(() => {
        btn.disabled = false;
        btn.innerHTML = originalText;
      });
    });
  });
}

// Fetch updated cart count and update all cart count badges
function updateCartCount() {
  fetch('/cart.json', {
    headers: { 'Accept': 'application/json' }
  })
  .then(res => res.json())
  .then(cart => {
    // Update all cart count badges in the header
    const cartCountEls = document.querySelectorAll('.okira-capsule-btn__cart-count');
    cartCountEls.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    // If there are no badges yet but cart has items, create them
    if (cartCountEls.length === 0 && cart.item_count > 0) {
      const cartBtns = document.querySelectorAll('.okira-header__cart-btn');
      cartBtns.forEach(cartBtn => {
        const badge = document.createElement('span');
        badge.className = 'okira-capsule-btn__cart-count';
        badge.textContent = cart.item_count;
        cartBtn.appendChild(badge);
      });
    }
  })
  .catch(() => {});
}

// Toast notification helper
function showOkiraToast(message, type) {
  // Remove existing toast if present
  const existingToast = document.querySelector('.okira-toast');
  if (existingToast) existingToast.remove();

  // Pick icon based on type
  let icon = '✴';
  let iconColor = '#f2a6b2';
  if (type === 'success') { icon = '✓'; iconColor = '#38ef7d'; }
  if (type === 'error') { icon = '✕'; iconColor = '#ff5858'; }
  if (type === 'info') { icon = 'ℹ'; iconColor = '#6dd5ed'; }

  const toast = document.createElement('div');
  toast.className = 'okira-toast';
  toast.innerHTML = `
    <div class="okira-toast__content">
      <span class="okira-toast__star">${icon}</span>
      <span class="okira-toast__text">${message}</span>
    </div>
  `;
  
  Object.assign(toast.style, {
    position: 'fixed',
    bottom: '30px',
    right: '30px',
    backgroundColor: '#121212',
    color: '#fafafa',
    fontFamily: "'Neue Montreal', sans-serif",
    fontSize: '1.4rem',
    fontWeight: '700',
    padding: '16px 28px',
    borderRadius: '40px',
    zIndex: '10000',
    display: 'flex',
    alignItems: 'center',
    boxShadow: '0 10px 40px rgba(0,0,0,0.3)',
    transform: 'translateY(100px) scale(0.9)',
    opacity: '0',
    transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
  });

  document.body.appendChild(toast);

  const star = toast.querySelector('.okira-toast__star');
  if (star) {
    star.style.marginRight = '10px';
    star.style.color = iconColor;
    star.style.fontSize = '1.6rem';
  }

  requestAnimationFrame(() => {
    toast.style.transform = 'translateY(0) scale(1)';
    toast.style.opacity = '1';
  });

  setTimeout(() => {
    toast.style.transform = 'translateY(-20px) scale(0.95)';
    toast.style.opacity = '0';
    setTimeout(() => toast.remove(), 400);
  }, 3500);
}

// Auto-run on load
document.addEventListener('DOMContentLoaded', () => {
  initCollectionGrid();

  // Bind all cart buttons to open the cart drawer manually
  const cartBtns = document.querySelectorAll('.okira-header__cart-btn, #cart-icon-bubble');
  cartBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      const drawer = document.querySelector('cart-drawer');
      if (drawer) {
        e.preventDefault();
        e.stopPropagation();
        drawer.open(btn);
      }
    });
  });

  // Handle Hero Search Bar with custom Natural Language price matching
  const heroSearch = document.getElementById('okiraHeroSearch');
  if (heroSearch) {
    heroSearch.addEventListener('submit', (e) => {
      e.preventDefault();
      const input = document.getElementById('okiraHeroSearchInput');
      const query = input.value.trim().toLowerCase();
      
      if (!query) return;

      // Match "under 1000", "under 1000rs", "< 1000", "below 1000", "under 1000 rs"
      const priceMatch = query.match(/(under|below|<)\s*(\d+)/i);
      if (priceMatch && priceMatch[2]) {
        const price = parseInt(priceMatch[2], 10);
        // Redirect to collections with max price filter
        window.location.href = `/collections/all?filter.v.price.gte=0&filter.v.price.lte=${price}`;
        return;
      }

      // Match "over 1000", "above 1000", "> 1000"
      const priceOverMatch = query.match(/(over|above|>)\s*(\d+)/i);
      if (priceOverMatch && priceOverMatch[2]) {
        const price = parseInt(priceOverMatch[2], 10);
        // Redirect to collections with min price filter
        window.location.href = `/collections/all?filter.v.price.gte=${price}`;
        return;
      }

      // Default to standard Shopify product search
      window.location.href = `/search?type=product&q=${encodeURIComponent(query)}`;
    });
  }
});

